import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
	faTools,
	faStar,
	faChevronUp
} from "@fortawesome/free-solid-svg-icons";
import PopupMenu from "../../common/PopupMenu";
import React, {useContext} from "react";
import ThreadActionItems from "./ThreadActionItems";
import {ThreadContext} from "../../../context/threadContext";

const MenuButton = ({title, icon, url = null}) => {
	if (url) {
		return (
			<a href={url ? url : '#'} className="py-1 px-2 text-sm text-white bg-primary rounded-md inline-flex items-center gap-x-2">
				<span>{icon}</span>
				<span>{title}</span>
			</a>
		);
	} else {
		return (
			<div className="py-1 px-2 text-sm text-white bg-primary rounded-md inline-flex items-center gap-x-2">
				<span>{icon}</span>
				<span>{title}</span>
			</div>
		);
	}
}

const ThreadActionButtons = ({thread}) => {
	const { bump, threadData } = useContext(ThreadContext);

	return (
		<div className="inline-flex flex-col gap-2">
			{threadData.bumpMessage !== '' && (
				<p className="mt-2 message text-white font-bold text-sm">{threadData.bumpMessage}</p>
			)}

			<div className="inline-flex whitespace-nowrap items-center gap-x-2">
				<PopupMenu label={
					<MenuButton title={'Công cụ'} icon={<FontAwesomeIcon icon={faTools}/>}/>
				}>
					<div className="szh-menu-container-background">
						<ThreadActionItems thread={thread}/>
					</div>
				</PopupMenu>

				{thread.can_rate && (
					<MenuButton
						title={'Đánh giá em hàng'}
						icon={<FontAwesomeIcon icon={faStar}/>}
						url={`${thread.view_url}br-rate`}
					/>
				)}

				{thread.can_bump && (
					<button
						onClick={threadData.bumpMessage === '' ? bump : ''}
						className={`button button--cta bg-primary py-1 px-2 ${threadData.bumpMessage !== '' && 'grayscale cursor-not-allowed'} lg:flex-grow-0 lg:flex-shrink-0`}
					 >
						<FontAwesomeIcon icon={faChevronUp} className="mr-2"/>
						Bump
					</button>
				)}
			</div>
		</div>
	);
}

export default ThreadActionButtons;